'use client';
import { useReadShinkaiTokenAllowance } from '../generated';
import { getShinkaiTokenAddress } from '../contracts';
import { useEvmWallet } from './useEvmWallet';

export const useGetUserKaiTokenAllowance = (spender: `0x${string}`) => {
  const { address } = useEvmWallet();
  return useReadShinkaiTokenAllowance({
    address: getShinkaiTokenAddress(),
    args: [address!, spender],
    query: {
      enabled: address !== undefined,
      staleTime: 60000,
    },
  });
};
